// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import DefaultReviewCard from "custom/Cards/ReviewCards/DefaultReviewCard";

// Images
import agbarLogo from "assets/images/logos/gray-logos/agbar-grey.png";
import tousLogo from "assets/images/logos/gray-logos/tous-grey.png";
import adamoLogo from "assets/images/logos/gray-logos/adamo-grey.png";
import eunivLogo from "assets/images/logos/gray-logos/euniv-grey.png";
import micasinoLogo from "assets/images/logos/gray-logos/micasino-grey.png";
import prosegurLogo from "assets/images/logos/gray-logos/prosegur-grey.png";
import ccooLogo from "assets/images/logos/gray-logos/ccoo-grey.png";

function Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h2">Hemos conectado con</MKTypography>
          <MKTypography variant="h2" color="info" textGradient mb={2}>
            personas y empresas
          </MKTypography>
          <MKTypography variant="body1" color="text" mb={2}>
            Empresas Fortune 500, startups, universidades e instituciones gubernamentales han confiado en nosotros.
          </MKTypography>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 8 }}>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Carlos Pérez"
              date="2024"
              review="El curso en ciberseguridad e IA fue muy educativo. Aprendí mucho y ahora me siento más preparado para enfrentar los nuevos desafíos."
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              color="info"
              name="Ana Gómez"
              date="2024"
              review="El equipo de red team hizo un trabajo excelente. Identificaron vulnerabilidades críticas y nos ayudaron a mejorar nuestra seguridad."
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Luis Martínez"
              date="2024"
              review="Los pentests realizados por el equipo fueron muy detallados y profesionales. Nos proporcionaron un informe completo con recomendaciones claras."
              rating={5}
            />
          </Grid>
        </Grid>
        <Divider sx={{ my: 6 }} />
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item xs={6} md={4} lg={2} container alignItems="center" justifyContent="center">
            <MKBox component="img" src={agbarLogo} alt="Agbar" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2} container alignItems="center" justifyContent="center">
            <MKBox component="img" src={tousLogo} alt="Tous" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2} container alignItems="center" justifyContent="center">
            <MKBox component="img" src={adamoLogo} alt="Adamo" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2} container alignItems="center" justifyContent="center">
            <MKBox component="img" src={eunivLogo} alt="Euniv" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2} container alignItems="center" justifyContent="center">
            <MKBox component="img" src={micasinoLogo} alt="MiCasino" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2} container alignItems="center" justifyContent="center">
            <MKBox component="img" src={prosegurLogo} alt="Prosegur" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2} container alignItems="center" justifyContent="center">
            <MKBox component="img" src={ccooLogo} alt="CCOO" width="100%" opacity={0.6} />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;